export const SAVINGS_LIMIT = 3;
export const INCOME_SOURCES_LIMIT = 3;
export const EXPENSE_CATEGORIES_LIMIT = 12;
